module.exports = __webpack_public_path__ + "img/place_centre_bw.ccf71cf0.webp";